import React, { useState } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import { MapPin, Phone, Envelope, Clock, FacebookLogo, InstagramLogo, TwitterLogo } from 'phosphor-react';
import { useSidebar } from '../context/SidebarContext';

const Footer = () => {
  const { openSidebar } = useSidebar();
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    openSidebar('login');
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    openSidebar('register');
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-company">
            <img src={logo} alt="MercadoTV" className="footer-logo" />
            <p>MercadoTV - Especialistas em Segurança Eletrónica</p>
            <p>Todos os custos são feitos sem mensalidade (custo de compra/instalação apenas)</p>
          </div>

          <div className="footer-contact">
            <div className="contact-item">
              <MapPin size={20} />
              <span>Rua do Mercado nº298, Vale de Cambra, Portugal</span>
            </div>
            <div className="contact-item">
              <Phone size={20} />
              <span>+351 256 418 202</span>
            </div>
            <div className="contact-item">
              <Envelope size={20} />
              <span>mlptelecomunicacoes@gmail.com</span>
            </div>
            <div className="contact-item">
              <Clock size={20} />
              <span>Seg-Sex: 9h-12h | 14h-19h | Sáb: 9h-12h30</span>
            </div>
          </div>

          <div className="footer-social">
            <h4>Siga-nos</h4>
            <div className="social-icons">
              <a href="https://www.facebook.com/mercadotvlc" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FacebookLogo size={24} />
              </a>
              <a href="#instagram" className="social-icon">
                <InstagramLogo size={24} />
              </a>
              <a href="#twitter" className="social-icon">
                <TwitterLogo size={24} />
              </a>
            </div>
          </div>

          <div className={`footer-section ${openSections.conta ? 'open' : ''}`}>
            <h3 onClick={() => toggleSection('conta')}>CONTA</h3>
            <ul>
              <li><button onClick={handleLoginClick} className="footer-link">Iniciar Sessão</button></li>
              <li><button onClick={handleRegisterClick} className="footer-link">Registar-se</button></li>
              <li><Link to="/lista-interesse" className="footer-link">Lista de Interesse</Link></li>
              <li><Link to="/orders" className="footer-link">Pedidos</Link></li>
            </ul>
          </div>

          <div className={`footer-section ${openSections.legal ? 'open' : ''}`}>
            <h3 onClick={() => toggleSection('legal')}>INFORMAÇÃO LEGAL</h3>
            <ul>
              <li><Link to="/termos-e-condicoes">Termos e Condições</Link></li>
            </ul>
          </div>

          <div className={`footer-section ${openSections.mercadotv ? 'open' : ''}`}>
            <h3 onClick={() => toggleSection('mercadotv')}>MERCADOTV</h3>
            <ul>
              <li><Link to="/sobre">Sobre a MercadoTV</Link></li>
              <li><Link to="/contactos">Contactos</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>©2025 MercadoTV. Todos os direitos reservados.</p>
          </div>
          <div className="footer-disclaimer">
            <p>
              As imagens apresentadas podem não corresponder às especificações do produto no Mercado Português. 
              Por questões técnicas, as cores apresentadas podem diferir ligeiramente das cores reais.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
